module.exports = __webpack_public_path__ + "img/common-file-text-search.9f262e01.svg";